import BaseApi from "./base.api";
import ApiService from "@services/api.service";
export default {
  ...BaseApi,
  ...{
    resource: "admission-users",
  },
  getReferenceNumber(params = null) {
    return ApiService.get(`/autoReferenceNumber`, params);
  },
  getAgeValue(params = null) {
    return ApiService.get(`/getAgeValue`, params);
  },
  changeStudentPaidStatus(params = null) {
    return ApiService.get(`/changeStudentPaidStatus`, params);
  },
  storeAdmissionUserRequiredPaper(params = null) {
    return ApiService.post(
      `/admission-users/required-papers/storeAdmissionUserRequiredPaper`,
      params
    );
  },
  deleteStudentPaperRequired(params = null) {
    return ApiService.delete(`files/` + params);
  },
  updateStudentPaperRequired(params = null) {
    return ApiService.post(
      `admission-users/required-papers/updateAdmissionUserRequiredPaper`,
      params
    );
  },
  acceptToRegister(params = null) {
    return ApiService.get(`/${this.resource}/acceptToRegister/${params["id"]}`);
  },
  admissionReport(params = null) {
    return ApiService.get(`/${this.resource}/admission-report`, params);
  },
  checkAdmissionDate(params = null) {
    return ApiService.post(`/checkAdmissionDate`, params);
  },
  adminAction(params = null) {
    return ApiService.post(`/${this.resource}/files/action`, params);
  },
  addToAdmission(id, params = null) {
    return ApiService.get(`/${this.resource}/changeWaitingList/${id}`, params);
  },
  finishedPapers(params = null) {
    return ApiService.post(`/${this.resource}/finished-papers`, params);
  },
  printPapers(id, params = null) {
    return ApiService.get(`/${this.resource}/print-papers/${id}`, params);
  },
  exportExcel(params) {
    return ApiService.post(`${this.resource}/excel`, params);
  },
  storeStepOne(params = null) {
    return ApiService.post(`${this.resource}/store-step-one`, params);
  },

  storeStepTwo(params = null) {
    return ApiService.post(`${this.resource}/store-step-two`, params);
  },

  storeStepThree(params = null) {
    return ApiService.post(`${this.resource}/store-step-three`, params);
  },

  storeFull(params = null) {
    return ApiService.post(`${this.resource}/store-full`, params);
  },

  updateFull(params = null) {
    return ApiService.put(`${this.resource}/update-full`, params);
  },

  getAdmissionUserByEmailOrUsername(value) {
    return ApiService.get(
      `${this.resource}/admission-by-email-or-username/${value}`
    );
  },
  getAdmission(id, params = null) {
    return ApiService.get(`/${this.resource}/form/${id}`, params);
  },

  getAdmissionUserByFather(params = null) {
    return ApiService.get(`${this.resource}/admission-by-father`, params);
  },
  getAcceptedAdmissions(params = null) {
    return ApiService.get(`${this.resource}/accepted-admissions`, params);
  },
};
